export const REMOVE_SR_FAMILY_MEMBER_MODAL = 'REMOVE_SR_FAMILY_MEMBER_MODAL';
